/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Consult_Q1Inputs */

const en_consult_q1 = /** @type {(inputs: Consult_Q1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Where is your business today?`)
};

const id_consult_q1 = /** @type {(inputs: Consult_Q1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kondisi bisnismu sekarang?`)
};

/**
* | output |
* | --- |
* | "Where is your business today?" |
*
* @param {Consult_Q1Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const consult_q1 = /** @type {((inputs?: Consult_Q1Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Consult_Q1Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_consult_q1(inputs)
	return en_consult_q1(inputs)
});